import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow,
    CCardFooter,
} from '@coreui/react';
import { ThePermission } from '../ThePermission';
import Items from 'src/views/assets/Items';
import { itemActions, noteActions, userActions, provinceActions, storeActions } from 'src/_actions';
import { helps } from 'src/_helpers';

class ItemsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page_header: 'Quản Lý Danh Mục Tài Sản',
        }
    }

    componentDidMount() {
        this.getStores();

        if (helps.isEmpty(this.props.notes)) {
            this.props.getNotes('items');
        }

        if (helps.isEmpty(this.props.users)) {
            this.props.getUsers();
        }

        if (helps.isEmpty(this.props.items)) {
            this.props.getAll();
        }
    }

    async getStores() {
        if (helps.isEmpty(this.props.stores)) {
            await this.props.getStores();
        }
    }

    render() {
        return (
            <ThePermission {... this.props} component="assets" action="view" alertOut={true}>
                <CRow key={helps.convertToSlug(this.state.page_header)}>
                    <CCol xl={12}>
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol>
                                        {this.state.page_header}
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody className='items-table'>
                                <Items {... this.props} />
                            </CCardBody >
                            <CCardFooter>
                                Tổng: <b>{this.props.items && <>{this.props.items.length}</>}</b>
                            </CCardFooter>
                        </CCard >
                    </CCol >
                </CRow >
            </ThePermission>

        );
    }
}

function mapStateToProps(state) {
    const { loading, items } = state.itemReducer;
    const { provinces } = state.provinceReducer;
    const { users } = state.userReducer;
    const { notes } = state.noteReducer;
    const { stores } = state.storeReducer;
    return { loading, items, provinces, users, notes, stores };
}

const actionCreators = {
    getAll: itemActions.getAll,
    getProvinces: provinceActions.getAll,
    getNotes: noteActions.getAll,
    getUsers: userActions.getAll,
    getStores: storeActions.getAll,
};

const connectedContainer = connect(mapStateToProps, actionCreators)(ItemsContainer);
export { connectedContainer as ItemsContainer };